export default __webpack_public_path__ + "static/media/sequenceNotShared3.03d69e8b.png";